// src/lib/strings.ts
export function ensureLeadingSlash(path: unknown): string {
  const s = (path ?? "").toString();
  return s.startsWith("/") ? s : "/" + s;
}

export function stripTrailingSlash(url: unknown): string {
  const s = (url ?? "").toString();
  let i = s.length;
  while (i > 0 && s.charCodeAt(i - 1) === 47 /* '/' */) i--;
  return i === s.length ? s : s.slice(0, i);
}

export function joinUrl(base: unknown, path: unknown): string {
  const b = stripTrailingSlash(base);
  const p = ensureLeadingSlash(path);
  return b + p;
}
